(() => {
  function init() {
    const drawer=document.querySelector('[data-cart-drawer]');
    if(!drawer || drawer.dataset.ready)return;
    drawer.dataset.ready='true';
    const items=drawer.querySelector('[data-drawer-items]'),title=drawer.querySelector('[data-drawer-title]');
    const notice=drawer.querySelector('[data-drawer-notice]'),meter=drawer.querySelector('[data-shipping-meter]');
    const subtotal=drawer.querySelector('[data-drawer-subtotal]'),subtotalRow=drawer.querySelector('[data-drawer-subtotal-row]');
    const imageMap=new Map([...drawer.querySelectorAll('[data-preview-variant]')].map(item=>[item.dataset.previewVariant,item.dataset.previewImage]));
    const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer,animation,returnFocus,lastTotal=Number(drawer.dataset.total),pinned=false,revision=0,fillFrame,fillTimer,removing=false;
    const money=(amount,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(amount/100);
    const text=(tag,value,className)=>{const node=document.createElement(tag);node.textContent=value;if(className)node.className=className;return node;};
    const arm=()=>{clearTimeout(timer);if(!pinned)timer=setTimeout(()=>{if(drawer.contains(document.activeElement)||drawer.matches(':hover'))return;close();},5500);};
    function close() {
      if(drawer.hidden)return;
      clearTimeout(timer);animation?.cancel();
      const finish=()=>{drawer.hidden=true;animation=null;document.querySelectorAll('.bag-button').forEach(link=>link.setAttribute('aria-expanded','false'));};
      if(drawer.contains(document.activeElement)) (returnFocus?.isConnected?returnFocus:document.querySelector('.bag-button'))?.focus({preventScroll:true});
      if(reduced()){finish();return;}
      animation=drawer.animate([{transform:'translateX(0)',opacity:1},{transform:'translateX(100%)',opacity:0}],{duration:260,easing:'ease-in'});
      animation.onfinish=finish;
    }
    function open(manual=false) {
      clearTimeout(timer);animation?.cancel();
      const wasHidden=drawer.hidden;drawer.hidden=false;pinned=manual;
      if(wasHidden){returnFocus=document.activeElement;if(!reduced())animation=drawer.animate([{transform:'translateX(100%)',opacity:.6},{transform:'translateX(0)',opacity:1}],{duration:360,easing:'cubic-bezier(.2,.8,.2,1)'});}
      document.querySelectorAll('.bag-button').forEach(link=>link.setAttribute('aria-expanded','true'));
      if(manual)drawer.querySelector('[data-drawer-close]').focus({preventScroll:true});
      arm();
    }
    function fillFrom(previous) {
      if(!meter || meter.hidden || reduced())return;
      const fill=meter.querySelector('[data-shipping-liquid]');
      cancelAnimationFrame(fillFrame);clearTimeout(fillTimer);
      const target=fill.style.width;
      fill.style.transition='none';fill.style.width=`${Math.min(100,Math.max(0,previous/Number(meter.dataset.threshold)*100))}%`;
      meter.classList.remove('is-filling');
      // Let the side panel enter before the liquid moves to the new cart total.
      fillTimer=setTimeout(()=>{fillFrame=requestAnimationFrame(()=>{fill.style.transition='';fill.style.width=target;meter.classList.add('is-filling');});},220);
    }
    function render(cart,preview) {
      const currency=cart.currency||drawer.dataset.currency;
      if(preview?.image)imageMap.set(String(preview.variantId),preview.image);
      document.querySelectorAll('[data-variant-select] option[data-image]').forEach(option=>imageMap.set(option.value,option.dataset.image));
      items.replaceChildren();
      if(!cart.items.length)items.append(text('p','Your bag is waiting for something unforgettable.','cart-preview__empty'));
      for(const item of cart.items){
        const row=document.createElement('article');row.className='cart-preview__item';
        const isWrap=item.properties?._hp_gift_wrap==='order';
        const photo=imageMap.get(String(item.variant_id))||item.featured_image?.url||item.image;
        if(photo && !isWrap){const image=document.createElement('img');image.src=photo;image.alt=item.product_title;image.width=64;image.height=80;row.append(image);}else{const symbol=text('span',isWrap?'✧':'','cart-preview__symbol');symbol.setAttribute('aria-hidden','true');row.append(symbol);}
        const copy=document.createElement('div');copy.append(text('h3',item.product_title));
        copy.append(text('p',isWrap?`${item.properties['Wrap design']||'Gift wrap'} · One per order`:`${item.variant_title&&item.variant_title!=='Default Title'?item.variant_title+' · ':''}Qty ${item.quantity}`));
        const remove=text('button','Remove','cart-preview__remove');remove.type='button';remove.dataset.drawerRemove=item.key;
        remove.setAttribute('aria-label',`Remove ${item.product_title}${item.variant_title&&item.variant_title!=='Default Title'?' — '+item.variant_title:''}`);
        remove.disabled=removing;copy.append(remove);
        row.append(copy,text('strong',money(item.final_line_price,currency)));items.append(row);
      }
      subtotal.textContent=money(cart.total_price,currency);subtotalRow.hidden=false;
      notice.hidden=true;items.scrollTop=0;
    }
    document.addEventListener('cart:updated',event=>{
      const cart=event.detail?.cart||event.detail;if(!cart?.items)return;
      revision++;
      const previous=lastTotal;lastTotal=cart.total_price;
      render(cart,event.detail?.addedPreview);
      if(event.detail?.source==='add'){
        title.textContent='Added to your bag';
        open();fillFrom(previous);
      }
      if(event.detail?.source==='remove'){
        title.textContent=cart.items.length?'Your bag':'Your bag is empty';
        fillFrom(previous);
      }
    });
    items.addEventListener('click',async event=>{
      const button=event.target.closest('[data-drawer-remove]');
      if(!button || removing)return;
      removing=true;pinned=true;clearTimeout(timer);revision++;
      const index=[...items.querySelectorAll('[data-drawer-remove]')].indexOf(button);
      items.setAttribute('aria-busy','true');
      items.querySelectorAll('[data-drawer-remove]').forEach(control=>control.disabled=true);
      button.textContent='Removing…';notice.textContent='Updating your bag…';notice.hidden=false;
      try{
        // Share the full bag's removal logic, including orphan gift-wrap cleanup.
        const {removeCartLine}=await import(drawer.dataset.giftModule);
        const request=async(path,body)=>{
          const response=await fetch(drawer.dataset.root+path,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{method:'POST',body:JSON.stringify(body)}:{})});
          const data=await response.json();
          if(!response.ok)throw new Error(typeof data.description==='string'?data.description:'We could not remove this item. Please try again.');
          return data;
        };
        const cart=await removeCartLine({request,key:button.dataset.drawerRemove});
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart,source:'remove'}}));
        notice.textContent=cart.items.length?'Item removed.':'Your bag is now empty.';notice.hidden=false;
        const controls=[...items.querySelectorAll('[data-drawer-remove]')];
        controls.forEach(control=>control.disabled=false);
        if(!drawer.hidden)(controls[Math.min(index,controls.length-1)]||drawer.querySelector('[data-drawer-close]')).focus({preventScroll:true});
      }catch(error){
        notice.textContent=error.message||'We could not remove this item. Please try again.';notice.hidden=false;
        if(button.isConnected)button.textContent='Remove';
      }finally{
        removing=false;items.removeAttribute('aria-busy');
        items.querySelectorAll('[data-drawer-remove]').forEach(control=>control.disabled=false);
      }
    });
    document.addEventListener('cart:add-refresh-failed',()=>{
      revision++;title.textContent='Added to your bag';items.replaceChildren();subtotalRow.hidden=true;if(meter)meter.hidden=true;
      notice.textContent='Your item was added. Open your bag to see the latest items and total.';notice.hidden=false;open();
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(button=>button.addEventListener('click',close));
    drawer.addEventListener('pointerenter',()=>clearTimeout(timer));drawer.addEventListener('pointerleave',arm);
    drawer.addEventListener('pointerdown',()=>{pinned=true;clearTimeout(timer);});
    drawer.addEventListener('focusin',()=>clearTimeout(timer));drawer.addEventListener('focusout',arm);
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!drawer.hidden)close();});
    document.addEventListener('newsletter:opened',close);
    document.addEventListener('pointerdown',event=>{if(!drawer.hidden&&!drawer.contains(event.target)&&!event.target.closest('.bag-button'))close();});
    document.querySelectorAll('.bag-button').forEach(link=>{
      link.setAttribute('aria-controls','CartPreview');link.setAttribute('aria-expanded','false');
      link.addEventListener('click',async event=>{
        if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
        // Keep the cart page's own bag navigation and unsaved gift options intact.
        if(document.querySelector('.cart-form'))return;
        event.preventDefault();title.textContent='Your bag';open(true);
        notice.textContent='Updating your bag…';notice.hidden=false;
        const requestRevision=++revision;
        try{
          const response=await fetch(`${drawer.dataset.root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'});
          if(!response.ok)throw new Error('Cart refresh failed');const cart=await response.json();
          if(revision===requestRevision)document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart,source:'drawer'}}));
        }catch{if(revision===requestRevision){notice.textContent='Open your bag to see the latest items and total.';notice.hidden=false;}}
      });
    });
  }
  document.addEventListener('DOMContentLoaded',init);
})();
